import React, { useMemo } from "react";
import Application from "../../types/Application";
import { Modal } from "react-bootstrap";
import LoadingSpinner from "../Common/LoadingSpinner";
import { TargetGroup } from "../../common/enums";
import SelectionComment from "../../types/SelectionComment";
import { targetGroupNames } from "../../common/applicationUtils";

type Props = {
    application: Application | undefined;
    isCulturalManagement: boolean;
    show: boolean;
    onHide: () => void;
};

const targetGroupSortOrder = {
    PreSchool: 0,
    SchoolLower: 1,
    SchoolMiddle: 2,
    SchoolUpper: 3,
    HighSchool: 4,
    Other: 5,
    Total: 6,
} as const as any;

function AllApplicationSelectionCommentsModal(props: Props) {
    const application = props.application;
    const orderedComments =
        props.application?.selectionComments
            .filter(
                (c) =>
                    c.isCulturalManagement === props.isCulturalManagement &&
                    c.comment &&
                    Object.keys(targetGroupSortOrder).includes(c.targetGroup),
            )
            .sort((a, b) => targetGroupSortOrder[a.targetGroup] - targetGroupSortOrder[b.targetGroup]) ?? [];

    return (
        <Modal show={props.show} onHide={props.onHide}>
            {application ? (
                <>
                    <Modal.Header closeButton>
                        <Modal.Title>Kommentarer för {application.document.eventName}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>Målgrupp</th>
                                    <th>Kommentar</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orderedComments.map((c) => (
                                    <tr key={c.applicationId + c.targetGroup}>
                                        <td>{targetGroupNames[c.targetGroup]}</td>
                                        <td>{c.comment}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Modal.Body>
                </>
            ) : (
                <LoadingSpinner />
            )}
        </Modal>
    );
}

export default AllApplicationSelectionCommentsModal;
